export default __webpack_public_path__ + "images/syc2_227e88.svg";